module.exports = __webpack_public_path__ + "static/media/travel9.575e09b9.jpg";